import { ChangeDetectionStrategy, Component, EventEmitter, Input, Optional, Output, Self } from '@angular/core';
import { NgControl } from '@angular/forms';
import { ValidationMessageService } from '@common/services/validation-message.service';
import { AbstractFormControlComponent } from './abstract-form-control.component';

@Component({
    selector: 'form-textbox-with-button',
    styleUrls: ['form-controls.component.scss'],
    template: `
        <div class="form-group" [ngClass]="{ 'has-value': !!value }">
            <app-control
                [type]="textboxType"
                [isDisabled]="isDisabled"
                [label]="labelText"
                [placeholder]="placeholder"
                [ngClass]="{ 'is-invalid': isInvalid }"
                [isInvalid]="isInvalid"
                [formControlValidators]="getFormControlValidators"
                [contextual]="contextual"
                [buttonIcon]="icon"
                [buttonTooltip]="tooltipText"
                [(ngModel)]="value"
                (ngModelChange)="changeValue($event)"
                (textboxWithButtonClick)="onButtonClick()"></app-control>
        </div>
    `,
    providers: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TextboxWithButtonComponent extends AbstractFormControlComponent {
    @Input() labelText: string;
    @Input() contextual: string = null;
    @Input() isDisabled: boolean;
    @Input() textboxType = 'string';
    @Input() icon: string = undefined;
    @Input() placeholder: string;
    @Input() tooltipText: string = '';

    @Output() buttonClick = new EventEmitter<void>();

    constructor(@Self() @Optional() controlDir: NgControl, validationMessageService: ValidationMessageService) {
        super(controlDir, validationMessageService);
    }

    onButtonClick() {
        this.buttonClick.emit();
    }
}
